import React from "react";
import { Receipt } from "lucide-react";
import BillingSettingsCard from "@/components/billing/admin/BillingSettingsCard";

export default function AdminBillingPage() {
  return (
    <div className="space-y-6" data-testid="admin-billing-page">
      <div>
        <p className="text-xs uppercase tracking-wider text-slate-500 font-medium flex items-center gap-1.5">
          <Receipt className="h-3.5 w-3.5" /> Admin
        </p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 font-display">Billing Information</h1>
        <p className="text-sm text-slate-600 mt-1 max-w-2xl">
          Go-live switch, plan price and included credits, exchange rate and markup, credit packs, taxes and the details printed on receipts.
          Per-member grants, refunds and cancellations live under Users → Billing.
        </p>
      </div>
      <BillingSettingsCard />
    </div>
  );
}
